module.exports = __webpack_public_path__ + "img/title3.e8a8efa8.png";